import React from 'react';
import Image from '../assets/gigig.gif';
import { TypeAnimation } from 'react-type-animation';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

// import Step from '../assets/step.png';
// import Step2 from '../assets/step2.png';

const Banner = () => {
  return (
    <section className='min-h-[85vh] lg:min-h-[78vh] flex items-center' >
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>

          <div className='flex justify-between items-center mb-[-130px] flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12 '>



            {/* <div className='flex justify-between items-center mb-[-130px] flex-col gap-y-8 lg:flex-column lg:items-center lg:gap-x-12'>
      <img src={Step2} alt='' className='w-[190px] h-[190px] pl-[65px] z-50 object-cover'/>
      <img src={Step2} alt='' className='w-[190px] h-[190px] mb-[-130px] z-50  pb-[53px]  object-cover z-55'/>
      </div> */}

          </div>
          {/* text */}
          <div className='flex-1 text-center pt-9 font-secondary lg:text-left' id='banner'>
            <motion.h1
              variants={fadeIn('up', 0.3)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='text-[55px] font-bold leading-[0.8] lg:text-[110px] text-[#263661]'>
              Jupy <span>Cats</span>
            </motion.h1>
            <motion.div
              variants={fadeIn('up', 0.5)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-9 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]'>
              <span className=' text-white first:mr-4'>We Are a</span>
              <TypeAnimation
                sequence={[
                  'Nft Builders',
                  2000,
                  'Art Makers',
                  2000,
                ]}
                speed={50}
                className='text-accent'
                wrapper='span'
                repeat={Infinity}
              />
            </motion.div>
            {/* <motion.p
            variants={fadeIn('up',0.6)}
            initial='hidden'
            whileInView={'show'}
            viewport={{once:false,amount:0.7}}
             className='mb-8 max-w-lg mx-auto lg:mx-0'>Lorem dfbks fdgjf dgndfgdf  dfgjdfgjdfj</motion.p> */}

            {/* socials */}
            {/* <motion.div
              variants={fadeIn('up', 0.8)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='flex text-[20px] gap-x-6 max-w-max mx-auto
            lg:mx-0'>
              <a href='#'>
                <FaYoutube />
              </a>
              <a href='#'>
                <FaGithub />
              </a>
              <a href='#'>
                <FaDribbble />
              </a>
            </motion.div> */}

          </div>

          {/* image */}
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial='hidden'
            whileInView={'show'}
            className=' lg:flex flex-1 max-w-[320px] lg:max-w-[480px] '>
            <img src={Image} alt='GIF' />
          </motion.div>
        </div>
      </div>
    </section>
  )
};

export default Banner;
